module.exports = __webpack_public_path__ + "img/stock1.fb7e6a10.png";